module.exports = __webpack_public_path__ + "static/img/IMG_20240326_112155.2e673ece.jpg";